import axios from "axios";

export const getSchool = () =>
  axios.get("/api/public/school").then((response) => response.data);
